"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractUniqueDiscountPolicies = void 0;
const extractUniqueDiscountPolicies = (data) => {
    const uniquePolicies = new Map();
    data.forEach((item) => {
        const policy = item?.discount;
        if (policy && !uniquePolicies.has(policy.id)) {
            uniquePolicies.set(policy.id, policy);
        }
    });
    return Array.from(uniquePolicies.values());
};
exports.extractUniqueDiscountPolicies = extractUniqueDiscountPolicies;
